import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import RichText from "common/blocks/RichText";
import SmartLink from "common/wrapper/SmartLink";
import { ResolvedRichText } from "resolvers/data/richTextResolver";

import styles from "./ExtrasCard.module.scss";

const cx = classNames.bind(styles);

export type ExtrasCardProps = {
    headingText: string;
    subHeadingText: string;
    bodyText: ResolvedRichText;
    cardLinkText: string;
    urlLink: string;
    image: string;
};

const ExtrasCard = ({
    headingText,
    subHeadingText,
    bodyText,
    cardLinkText,
    urlLink,
    image,
}: ExtrasCardProps) => (
    <div className={cx("extrasCard")}>
        <div className={cx("extrasImageContainer")}>
            <Image className={cx("extrasImage")} alt={""} src={image} layout="fill" />
        </div>
        <div className={cx("extrasContentContainer")}>
            <div className={cx("topContentContainer")}>
                <div className={cx("cardHeading")}>{headingText}</div>
                <div className={cx("cardSubHeading")}>{subHeadingText}</div>
                <div className={cx("cardBodyText")}>
                    <RichText html={bodyText.html} resolvedItems={bodyText.resolvedItems} />
                </div>
            </div>
            <div className={cx("bottomContentContainer")}>
                <SmartLink href={urlLink}>
                    <a target="_blank" className={cx("cardLink")}>
                        {cardLinkText}
                    </a>
                </SmartLink>
            </div>
        </div>
    </div>
);

export default ExtrasCard;
